import { StoryblokLink } from '@/components/shared/storyblok-link'
import { Badge } from '@/components/ui/badge'
import { NavigationMenuLink } from '@/components/ui/navigation-menu'
import type { GlobalNavSubMenuColLinksStoryblok } from '@/lib/types/component-types-sb'

export function NavSubMenuColLinks({ col }: { col: GlobalNavSubMenuColLinksStoryblok }) {
  return (
    <div
      key={col._uid}
      className="space-y-2"
    >
      <span className="text-muted-foreground block px-2.5 text-sm font-medium">{col.title}</span>
      <div className="flex flex-col items-start gap-2.5">
        {col.links?.map((item) => {
          return (
            <NavigationMenuLink
              asChild
              key={item._uid}
            >
              <StoryblokLink
                prefetch={true}
                link={item.comingSoon ? null : item.target}
                className="hover:bg-muted flex flex-col rounded-md px-2.5 py-1.5 transition-colors"
              >
                {item.comingSoon ? (
                  <div className="flex items-center justify-between gap-2">
                    <span className="text-foreground">{item.label}</span>
                    <Badge
                      variant="brand"
                      className="text-xs"
                    >
                      Coming Soon
                    </Badge>
                  </div>
                ) : (
                  <span className="text-foreground">{item.label}</span>
                )}

                <span className="text-muted-foreground text-xs">{item.subTitle}</span>
              </StoryblokLink>
            </NavigationMenuLink>
          )
        })}
      </div>
    </div>
  )
}
